import { IActionResult } from '../types/IActionResult';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export enum GrantLicenseModes {
  ON_SYNC = 'on-sync',
  ON_LOGIN = 'on-login'
}

export interface ISyncActiveDirectoryGroupParams {
  name: string; // group name
  domainName: string; // group's domain name
  siteRole: string; // site role given to new users
  grantLicenseMode?: GrantLicenseModes; // determines what license mode for granting have for the group
}

export interface ISyncAdGroupCompleteResult extends IResult {
  usersAddedToGroup: number;
  usersAddedToSite: number;
  usersInActiveDirectoryGroup: number;
  usersProcessed: number;
  usersRemovedFromGroup: number;
  usersSiteRoleUpdated: number;
  usersSkipped: number;
  usersUnlicensed: number;
  usersUpdated: number;
  usersWithInsufficientLicenses: number;
}

export class SyncActiveDirectoryGroupRequest extends Request<ISyncActiveDirectoryGroupParams, IActionResult> {
  constructor(params: ISyncActiveDirectoryGroupParams) {
    super('syncActiveDirectoryGroup', params);
  }
}
